import { render } from "./OrdersMain.vue?vue&type=template&id=7052e3d7&scoped=true"
import script from "./OrdersMain.vue?vue&type=script&lang=js"
export * from "./OrdersMain.vue?vue&type=script&lang=js"

import "./OrdersMain.vue?vue&type=style&index=0&id=7052e3d7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7052e3d7"]])

export default __exports__